import { ApiClient } from "~/clApi/main/foundation/ApiClient"
import { BannerListView } from "~/clApi/viewModel/ad"

const basePath = "/ad/general"

export const read = {
  getBannerList: () =>
    new ApiClient<BannerListView | null>().get(`${basePath}/banner/list`),
}
